// extracted by mini-css-extract-plugin
module.exports = {"container":"_tcy5Zb4I","popoverContainer":"_NwQ2fHv6","text":"_lDSmZMlb","buttonText":"_CgcIyb0T","textLink":"_xMhPv9rj"};